














































































import { Component, Vue } from "vue-property-decorator";
import { delNullProperty } from "@/utils/index";
import axios from "axios";
import clue_select from './clue_select.vue';
import vantSelect from './vant-select.vue'

@Component({
  name: "AppLicationForm",
  components: { clueSelect:clue_select, vantSelect }
})
export default class extends Vue {
  private show = false;
  private gradeShow = false;  //年级
  private directionShow = false;  //咨询专业方向
  private selectName = "";

  private grade = "";
  private gradeList = [
    '美制7年级/英制8年级/初一（普高）',
    '美制8年级/英制9年级/初二（普高）',
    '美制9年级/英制10年级/初三（普高）',
    '美制10年级/英制11年级/高一（普高）',
    '美制11年级/英制12年级/高二（普高）', '美制12年级/英制13年级/高三（普高）',
    '大学一年级',
    '大学二年级',
    '大学三年级',
    '大学四年级',
    '研究生及以上',
    '已毕业'
  ];
  private marketName = "";
  private phone = "";
  private weChat = "";
  private email = "";
  private remark = "";
  private direction = "";
  private errorInfos = {
    // 存放对应输入框的报错信息，在提交的时候统一验证
    name: "",
    phone: "",
    weChat: "",
    email: "",
    grade: "",
    attendSchool: ""
  };
  private name = null;
  private schoolShow = false;
  private school = '';
  private schoolList = [];
  private schoolId = '';
  private schoolName = null;
  private page = 1;
  private axios = null;
  private resultSuccess = false; // 提交成功
  private resultError = false

  created() {
    this.createAxios();
    this.getSchoolList();
  }

  mounted() {
    this.setDocumentFontSize();
    window.addEventListener("resize", this.setDocumentFontSize);
  }

  createAxios() {
    const origin = location.hostname; //当前访问域名
    let requestBase = "";
    if (process.env.NODE_ENV === "development") {
      requestBase = process.env.VUE_APP_BASE_CRM_API_PROXY;
    } else {
      if (origin.indexOf("-testserver") > -1) {
        requestBase = process.env.VUE_APP_DEV_API;
      } else {
        requestBase = process.env.VUE_APP_MASTER_API;
      }
    }
    const config = {
      baseURL: requestBase,
      timeout: 30 * 1000, // Timeout
    };

    this.axios = axios.create(config);
  }

  destroyed() {
    document.documentElement.style.fontSize = "16px";
  }

  // 下拉多选传值展示
  handleChange(msg) {

    this.selectName = msg
  }

  showPopup () {
    this.schoolShow = true
  }

  handleSchool(data) {
    this.schoolList = data
  }

  listenSchool(data) {
    if(data != false){
      this.schoolId = data.id
      this.school = data.text
    }

    this.schoolShow = false
  }

  async getSchoolList() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.axios
        .post(
            "/tools/getSchoolList",
            delNullProperty({
              name: this.schoolName,
              page: this.page,
            })
        )
        .then(({ data }) => {
          // 判断错误状态
          this.schoolList = [...this.schoolList, ...data.data.schoolList]
          this.schoolList = this.schoolList.map(item => ({ id: item.id, text: item.name }))
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
  }

  gradeShowPopup () { //年级
    this.gradeShow = true
  }
  // 年级
  listenGrade(data) {
    if(data != false){
      this.grade = data
    }
    this.gradeShow = false
  }
  directionShowPopup () { //咨询专业方向
    this.directionShow = true
  }
  // 咨询专业方向
  listenDirection(data) {
    if(data != false){
      this.direction = data
    }
    this.directionShow = false
  }


  submitForm() {
    let isComplete = true;
    /* 清空报错信息 */
    for (const key in this.errorInfos) {
      this.errorInfos[key] = "";
    }
    /* 非空验证 */
    if (this.checkNull(this.marketName)) {
      this.errorInfos.name = "请填写学生姓名";
      isComplete = false;
    }
    if (this.checkNull(this.phone)) {
      this.errorInfos.phone = "请填写手机号";
      isComplete = false;
    }
    if (this.checkNull(this.weChat)) {
      this.errorInfos.weChat = "请填写微信号";
      isComplete = false;
    }
    if (this.checkNull(this.grade)) {
      this.errorInfos.grade = "请选择学生年级";
      isComplete = false;
    }
    if (this.checkNull(this.email)) {
      this.errorInfos.email = "请填写邮箱地址";
      isComplete = false;
    }
    if (this.checkNull(this.school)) {
      this.errorInfos.attendSchool = "请选择学校";
      isComplete = false;
    }

    if (isComplete) {
        this.setMarketClueByQrcode();
    }
  }

  checkNull(value: string | number): boolean {
    return ["", null, undefined, NaN].includes(value);
  }

  // 提交市场线索
  async setMarketClueByQrcode() {
    const loading = this.$loading({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    this.axios
        .post(
            "/market/setMarketClueByJzbm",
            delNullProperty({
              name: this.marketName,
              phone: this.phone,
              weChat: this.weChat,
              email: this.email,
              remark: this.remark,
              grade: this.grade,
              school:this.school,
            })
        )
        .then(({ data }) => {
          // 判断错误状态
          const error = data.error;
          if (error.returnCode === 1) {
            this.errorInfos.name = error.returnMessage;
          }
          if (error.returnCode === 0) {
            this.resultSuccess = true;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
          this.resultError = true
        });
  }

  closePage() {
    window.open("about:blank", "_self").close();
  }

  // 设置跟元素字体大小
  private setDocumentFontSize() {
    document.documentElement.style.fontSize =
        document.documentElement.getBoundingClientRect().width / 7.5 + "px";
  }
}
